












import Vue from 'vue'
import { GET_DISPOSITION_JOB_STATUS_LIST } from '@/store/getter-types'

interface ComponentData {
  items: any[]
  selectedItem: number | null
}

export default Vue.extend({
  name: 'SelectCellRenderer',

  data (): ComponentData {
    return {
      items: [],
      selectedItem: null
    }
  },

  methods: {
    onValueChange(value: number): void {
      // @ts-ignore
      this.params.data.status = value
    }
  },

  mounted () {
    // @ts-ignore
    if(this.params.data.status) {
      // @ts-ignore
      this.selectedItem = this.params.data.status
    }

    this.items = this.$store.getters[GET_DISPOSITION_JOB_STATUS_LIST]
  }
})
